export const defaultAiAssistantInfo = {
	title: "Ai Learning Assistant",
	alias: "AiLA",
	icon: "https://memorang-prod-media.s3.amazonaws.com/aila-default-icon.png",
};
